import { Group, Text } from '@mantine/core';
import type { ReadyResponse } from '@twinlink/shared';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '@web/lib/api';
import classes from './AppLayout.module.css';

/** Small "API online / unreachable" indicator in the top bar. Text + dot, never colour alone. */
export function ApiStatus() {
  const { t } = useTranslation();
  const { data, isError, isPending } = useQuery({
    queryKey: ['ready'],
    queryFn: () => api<ReadyResponse>('/ready', { anonymous: true }),
    refetchInterval: 30_000,
    retry: false,
  });
  if (isPending) return null;
  const ok = !isError && data?.status === 'ok';
  return (
    <Group gap={6} wrap="nowrap" visibleFrom="sm" role="status">
      <span className={classes.statusDot} style={{ background: ok ? 'var(--tl-success)' : 'var(--tl-danger)' }} />
      <Text size="xs" fw={600} c={ok ? undefined : 'red'}>
        {ok ? t('shell.apiOnline') : t('shell.apiOffline')}
      </Text>
    </Group>
  );
}
